import * as types from "./types";

const initialState = {
  exportList: [],
};

const applicantTabExportSheet = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_APPLICANTS_EXPORT_RESPONSE:
      return {
        ...state,
        exportList: action.payload,
      };
    default:
      return state;
  }
};
export default applicantTabExportSheet;
